var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 14,
    viewBox: "0 0 8 14",
    width: 8,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m234.042273 18.3219965c-.084321.1981483-.040169.4276302.111657.5803447l4.753197 4.91856-4.753197 4.91857c-.13386.1355102-.184571.332501-.132783.5158022.051789.1833011.198086.3246312.383065.3700596.18498.0454285.380103-.0120537.510911-.1505118l5.108215-5.28598c.198438-.2051561.198438-.5307139 0-.73587l-5.108215-5.28598c-.097992-.1043754-.234091-.1645962-.377238-.16692-.215315-.0035199-.411291.1237769-.495612.3219253z",
    fill: "#006aff",
    fillRule: "evenodd",
    stroke: "#006aff",
    transform: "translate(-233 -17)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronBlue);
export default __webpack_public_path__ + "static/media/chevron-blue.10b7a61f.svg";
export { ForwardRef as ReactComponent };